import usePluginEntities from "hooks/usePluginEntities";
const useWidgetActions = () => usePluginEntities("views.widgets.actions");
export default useWidgetActions;
